import http from "./http";

const baseUrl = "conference-web";


// 查询会议列表
const getConferenceList = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.get(baseUrl + '/conference/list', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 删除会议
const deleteConference = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.delete(baseUrl + '/conference', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 撤回会议
const callbackConference = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.post(baseUrl + '/conference/back', reqParam, true).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 其他类型会议的会议类型
// 新建综合会议时，也有个地方要选会议类型，就用这里的接口
const getOtherConferenceTypeList = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl + '/conference/type/dict/list', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }

  // 创建综合议题会议的议程，不是创建综合会议。
  // 创建综合会议分两步，先保存会议议程，再保存会议安排
  const createConferenceDeclaration = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/conference/declaration', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }

  //更新
  const updateConferenceDeclaration = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl + '/conference/declaration', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }

  const conferenceCountApi = () => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/conference/count', null, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }

  // 创建综合会议的会议安排
  const createConferencePlan = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/conference/declaration/plan', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }
/**
 * 直接提报的快捷方式
 * @param {*} params 
 * @returns 
 * 就很无语。标准的post方法用body传递数据不用，非要用url传递参数，这样仍然会url传递一份数据，body传递一份数据
 */
  const conferenceCommitAPi = (params) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + "/conference/commit?conferenceId=" + params.conferenceId, params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error)
        })
    })
  }

  /**
   * 查询会议打印类型
   * @returns 
   */
  const conferencePrintDictApi = () => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl + "/conference/print/dict/list", null, false).then(result => {
            resolve(result)
        }).catch(error => {
            reject(error)
        })
    })
  }
  

  // 创建其他类型议题会议
  const createOtherConference = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/conference/other', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }

  // 更新其他类型议题会议
  const editOtherConference = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl + '/conference/other', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }

  // 获取会议详情，综合的跟其他的是一个接口
  const getConferenceDetail = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl + '/conference/detail', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }

  
// 添加会议纪要
  const postConferenceSummary = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/conference/summary', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }
// 添加会议反馈
  const postConferenceFeedback = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + '/conference/feedback', reqParam, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
  }

export {
  deleteConference,
  getConferenceList,
  callbackConference,
  getOtherConferenceTypeList,
  createConferenceDeclaration,
  createOtherConference,
  editOtherConference,
  getConferenceDetail,
  createConferencePlan,
  postConferenceSummary,
  postConferenceFeedback,
  updateConferenceDeclaration,
  conferenceCommitAPi,
  conferencePrintDictApi,
  conferenceCountApi
}